import {Component, OnInit} from '@angular/core';
import {Observable, of} from 'rxjs';
import {EdrDataAddress, TransferProcessService} from "../../../mgmt-api-client";
import {TransferProcess} from "../../../mgmt-api-client/model";
import {AppConfigService} from "../../../app/app-config.service";
import {ConfirmationDialogComponent, ConfirmDialogModel} from "../confirmation-dialog/confirmation-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {JsonViewerDialogComponent, JsonViewerDialogData} from "../json-viewer-dialog/json-viewer-dialog.component";
import {ParamsInputDialogComponent, ParamsInputDialogData, ParamsInputResult} from "../params-input-dialog/params-input-dialog.component";

@Component({
  selector: 'edc-demo-transfer-history',
  templateUrl: './transfer-history-viewer.component.html',
  styleUrls: ['./transfer-history-viewer.component.scss']
})
export class TransferHistoryViewerComponent implements OnInit {

  columns: string[] = ['type', 'id', 'state', 'lastUpdated', 'assetId', 'contractId', 'action'];
  transferProcesses$: Observable<TransferProcess[]> = of([]);
  storageExplorerLinkTemplate: string | undefined;

  constructor(private transferProcessService: TransferProcessService,
              private dialog : MatDialog,
              private appConfigService: AppConfigService) {
  }

  ngOnInit(): void {
    this.loadTransferProcesses();
    this.storageExplorerLinkTemplate = this.appConfigService.getConfig()?.storageExplorerLinkTemplate
  }

  onDeprovision(transferProcess: TransferProcess): void {

    const dialogData = new ConfirmDialogModel("Confirm deprovision", `Deprovisioning resources for transfer [${transferProcess["@id"]}] will take some time and once started, it cannot be stopped.`)
    dialogData.confirmColor = "accent";
    dialogData.cancelColor = "warn";
    dialogData.confirmText = "Confirm";
    dialogData.cancelText = "Abort";
    //const ref = this.dialog.open(ConfirmationDialogComponent, {maxWidth: '20%', data: dialogData});
    const ref = this.dialog.open(ConfirmationDialogComponent, {disableClose: true, data: dialogData});

    ref.afterClosed().subscribe(res => {
      if (res) {
       this.transferProcessService.deprovisionTransferProcess(transferProcess["@id"]!).subscribe(() => this.loadTransferProcesses());
      }
    });
  }

  showStorageExplorerLink(transferProcess: TransferProcess) {
    return transferProcess.dataDestination?.properties?.type === 'AzureStorage' && transferProcess.state === 'COMPLETED';
  }

  showDeprovisionButton(transferProcess: TransferProcess) {
    return ['COMPLETED', 'PROVISIONED', 'REQUESTED', 'REQUESTED_ACK', 'IN_PROGRESS', 'STREAMING'].includes(transferProcess.state!);
  }

  showGetData(transferProcess: TransferProcess) {
    return transferProcess.state === 'STARTED' && transferProcess.type == 'CONSUMER'
  }

  onGetData(transferProcess: TransferProcess) {
    // Mostrar diálogo para pedir parámetros
    const paramsDialogData: ParamsInputDialogData = {
      title: "Configurar Parámetros de Petición (opcional)",
      message: "Especifica los parámetros de path y query para la petición de datos:"
    };
    
    const paramsDialogRef = this.dialog.open(ParamsInputDialogComponent, {
      data: paramsDialogData,
      width: '700px',
      disableClose: true
    });
    
    paramsDialogRef.afterClosed().subscribe((result: ParamsInputResult) => {
      console.log("Parameters dialog closed:", result);
      if (result) {
        this.fetchData(transferProcess, result.pathParams, result.queryParams);
      }
    });

  }
  
  private fetchData(transferProcess: TransferProcess, pathParams: string[], queryParams: { [key: string]: string }) {
    this.transferProcessService.getToken(transferProcess).subscribe({
      next: (edrDataAddress: EdrDataAddress) => {
        console.log("Data received:", edrDataAddress.authorization);
        console.log("Endpoint:", edrDataAddress.endpoint);
        this.transferProcessService.getData(edrDataAddress.authorization, edrDataAddress.endpoint, pathParams, queryParams).subscribe({
          next: (data) => {
            console.log("Data address received:", data);
            //IDOIA: Show data in a dialog
            const dialogData: JsonViewerDialogData = {
              title: "Data Address",
              json: data
            };
            this.dialog.open(JsonViewerDialogComponent, {
              data: dialogData,
              disableClose: true, 
              width: '800px',
              maxHeight: '80vh'
            });
          },
          error: (error) => {
            console.error("Error fetching data address:", error);
            //IDOIA: Show error in a dialog
            const dialogData = new ConfirmDialogModel("Error", `Error fetching data address: ${error.message}`);
            dialogData.confirmText = "Close";
            this.dialog.open(ConfirmationDialogComponent, {disableClose: true, data: dialogData});
          }
        });
      },
      error: (error) => {
        console.error("Error fetching data address:", error);
      }
    });
  }

  loadTransferProcesses() {
     this.transferProcesses$ = this.transferProcessService.queryAllTransferProcesses();
  }

  asDate(epochMillis?: number) {
    //IDOIA: Show hour
    //return epochMillis ? new Date(epochMillis).toLocaleDateString() : '';
    return epochMillis ? new Date(epochMillis).toLocaleString() : '';
  }
}
